<template>
    <div>
        <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10 }" v-model="textarea"
            :placeholder="config.placeholder"></el-input>
    </div>
</template>

<script>
export default {
    name: 'FromTextarea',
    components: {},
    props: {
        value: {
            type: String,
            default: ''
        },
        config: {
            type: Object,
            default: {}
        }
    },
    model: {
        event: 'change'
    },
    watch: {
        textarea(value) {
            this.$emit('change', value)
        },
        value(value) {
            this.textarea = value
        }
    },
    data() {
        return {
            textarea: this.value
        }
    },
    methods: {

    }
}
</script>
